// Retire only curated packages, preserving user-imported plugins and accounts.
const isRetiredBundled = id => id === 'bundled:tradingview-connected';
module.exports = { isRetiredBundled };
